import { render } from "./LabRelease2Dtl.vue?vue&type=template&id=05da89de"
import script from "./LabRelease2Dtl.vue?vue&type=script&lang=js"
export * from "./LabRelease2Dtl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__